import React, { useState, useEffect, useContext } from "react";
import { ethers } from "ethers";
import { Box, Center, Text, Spinner, VStack, Flex } from "@chakra-ui/react";
import { AppContext } from "../../AppContext";
import JakobFactory from "../../contracts/WalletFactoryArbitrum.json";
import { formatAddress } from "../../utils/formatMetamask";
import CopyToClipboardButton from "../../utils/CopyToClipboardButton";

const LoadPaymasterBalance = () => {
  const [paymasterAddress, setPaymasterAddress] = useState(null);
  const [paymasterBalance, setPaymasterBalance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { fastestWebSocket, contractAddress } = useContext(AppContext);
  const provider = new ethers.providers.WebSocketProvider(fastestWebSocket);

  // Fetch Paymaster Address
  const fetchPaymasterAddress = async () => {
    try {
      const factoryContract = new ethers.Contract(
        JakobFactory.address,
        JakobFactory.abi,
        provider
      );

      const details = await factoryContract.getWalletDetails(contractAddress);
      const paymasterAddr = details[9];
      setPaymasterAddress(paymasterAddr);
      return paymasterAddr;
    } catch (err) {
      console.error("Error fetching paymaster address:", err.message);
      setError(err.message);
      setLoading(false);
    }
  };

  // Fetch Paymaster ETH Balance
  const fetchPaymasterBalance = async (address) => {
    try {
      const balanceWei = await provider.getBalance(address);
      const balanceEth = parseFloat(ethers.utils.formatEther(balanceWei)).toFixed(4);
      setPaymasterBalance(balanceEth);
    } catch (err) {
      console.error("Error fetching paymaster balance:", err.message);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      setError(null);
      try {
        const address = await fetchPaymasterAddress();
        if (address) {
          await fetchPaymasterBalance(address);
        }
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    if (contractAddress) {
      loadData();
    }
  }, [contractAddress]);

  if (loading) {
    return (
      <Center w="100%" py={4}>
        <Spinner size="sm" />
      </Center>
    );
  }

  if (error) {
    return (
      <Center w="100%" py={4}>
        <Text color="red.500">Error: {error}</Text>
      </Center>
    );
  }

  if (!paymasterAddress) {
    return (
      <Center w="100%" py={4}>
        <Text>Loading Paymaster Address...</Text>
      </Center>
    );
  }

  return (
    <Flex
      w="100%"
      p={1}
      direction="column"
      align="center"
      justify="center"
      borderWidth="1px"
      borderRadius="md"
      shadow="md"
      backgroundColor="white"
      fontFamily="Sentinel-light"
    >
      <VStack spacing={3} w="100%" maxW="400px">
       {/**
        <Box textAlign="center" w="100%">
          <Text fontSize="sm" fontWeight="bold" mb={1}>
            Paymaster Address
          </Text>
          <Flex align="center" justify="center" gap={2}>
            <Text fontSize="xs" isTruncated maxW="240px">
              {formatAddress(paymasterAddress)}
            </Text>
            <CopyToClipboardButton value={paymasterAddress} />
          </Flex>
        </Box> */}

        <Box textAlign="center" w="100%">
          <Text fontSize="sm" fontWeight="bold" >
            Paymaster Balance
          </Text>
          <Text fontSize="md" color="green.500" fontWeight="bold">
            {paymasterBalance} ETH
          </Text>
        </Box>
      </VStack>
    </Flex>
  );
};

export default LoadPaymasterBalance;
